export interface FloaterDimensions {
  left: string;
  top: string;
  width: string;
  height: string;
  zIndex: string;
}

export const adjustFloaterPosition = (
  floater: HTMLElement,
  initialPosition: { left: number; top: number; width: number; height: number },
): FloaterDimensions => {
  const { left, top, width, height } = initialPosition;
  const viewportWidth = window.innerWidth;

  const floaterLeft = left;
  const floaterTop = top;
  let floaterWidth = width;
  let floaterHeight = height;

  if (floaterWidth + 16 > viewportWidth) {
    floaterWidth -= 16; /*                                      */
  }

  if (floaterTop < 0) {
    floaterHeight -= 16; /*                                       */
  }

  return {
    left: `${floaterLeft}px`,
    top: `${floaterTop}px`,
    width: `${floaterWidth}px`,
    height: `${floaterHeight}px`,
    zIndex:
      getComputedStyle(floater).getPropertyValue("--oc-floating-focus-v1-z-index") || "9999999999", /*                                                                     */
  };
};

export const checkIfFloaterExceedsViewport = (floater: HTMLElement): boolean => {
  const floaterBoundings = floater.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  return (
    floaterBoundings.left <= 0 ||
    floaterBoundings.top <= 0 ||
    floaterBoundings.right >= viewportWidth ||
    floaterBoundings.bottom >= viewportHeight
  );
};

const getFloaterPosition = (target: HTMLElement): FloaterDimensions => {
  const computedStyle = getComputedStyle(target);
  const { outlineOffset } = computedStyle;

  const padding = parseFloat(outlineOffset || "0px");
  const { width, height, left, top } = target.getBoundingClientRect();

  const zIndex = computedStyle.getPropertyValue("--oc-floating-focus-v1-z-index") || "9999999999"; /*                                                                     */

  if (checkIfFloaterExceedsViewport(target)) {
    return adjustFloaterPosition(target, {
      left: left + window.scrollX + width / 2,
      top: top + window.scrollY + height / 2,
      width: width + padding * 2,
      height: height + padding * 2,
    });
  }

  return {
    left: `${left + window.scrollX + width / 2}px`,
    top: `${top + window.scrollY + height / 2}px`,
    width: `${width + padding * 2}px`,
    height: `${height + padding * 2}px`,
    zIndex,
  };
};

export const repositionElement = (floater: HTMLElement, target: HTMLElement): void => {
  const styles = getFloaterPosition(target);
  Object.assign(floater.style, styles);
};
